import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Avatar from '../common/Avatar';
import StarRating from '../common/StarRating';
import { currency, rating } from '../../utils/formatters';

export default function TechnicianCard({ tech }) {
  const { t } = useTranslation();
  const name = `${tech.firstName} ${tech.lastName}`;
  return (
    <Link to={`/technicians/${tech.id}`} className="card pad tech-card">
      <div className="top">
        <Avatar src={tech.profilePictureUrl} name={name} />
        <div>
          <div className="name">{name}</div>
          <div className="meta">{tech.technicianTypeName}{tech.city ? ` · ${tech.city}` : ''}</div>
        </div>
      </div>
      <div className="spread">
        <span><StarRating value={tech.averageRating} /> <span className="muted">{rating(tech.averageRating)} ({tech.totalReviews || 0})</span></span>
        <span className="rate">{currency(tech.hourlyRate)}{t('common.perHour')}</span>
      </div>
      {tech.servicesOffered?.length > 0 && (
        <div className="tags">
          {tech.servicesOffered.slice(0, 3).map((s) => (
            <span key={s} className="badge gray">{s}</span>
          ))}
        </div>
      )}
      {!tech.availableForWork && <span className="badge amber">{t('technician.notAccepting')}</span>}
    </Link>
  );
}
